var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition-group', {
    staticClass: "tag-wrapper",
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, [_vm._l(_vm.activeTags, function (tag, index) {
    return [tag.type === 'rich' ? _c('tag-rich', _vm._b({
      key: "rich-".concat(tag._id),
      attrs: {
        "data-type": 'rich',
        "data-index": index,
        "data-tag-id": tag._id,
        "active": tag._id === _vm.activeTagId
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.setActiveTagId(tag._id);
        }
      }
    }, 'tag-rich', tag, false)) : _vm._e(), tag.type === 'reveal' ? _c('tag-reveal', _vm._b({
      key: "reveal-".concat(tag._id),
      attrs: {
        "data-type": 'reveal',
        "data-index": index,
        "data-tag-id": tag._id,
        "active": tag._id === _vm.activeTagId
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.setActiveTagId(tag._id);
        }
      }
    }, 'tag-reveal', tag, false)) : _vm._e(), tag.type === 'basic' ? _c('tag-basic', _vm._b({
      key: "basic-".concat(tag._id),
      attrs: {
        "data-type": 'basic',
        "data-index": index,
        "data-tag-id": tag._id,
        "active": tag._id === _vm.activeTagId
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.setActiveTagId(tag._id);
        }
      }
    }, 'tag-basic', tag, false)) : _vm._e(), tag.type === 'box' ? _c('tag-box', _vm._b({
      key: "box-".concat(tag._id),
      attrs: {
        "data-type": 'box',
        "data-index": index,
        "data-tag-id": tag._id
      }
    }, 'tag-box', tag, false)) : _vm._e(), tag.type === 'basicIcon' ? _c('tag-basic-icon', _vm._b({
      key: "basicIcon-".concat(tag._id),
      attrs: {
        "data-type": 'basicIcon',
        "data-index": index,
        "data-tag-id": tag._id
      }
    }, 'tag-basic-icon', tag, false)) : _vm._e(), tag.type === 'action' ? _c('tag-action', _vm._b({
      key: "action-".concat(tag._id),
      attrs: {
        "data-type": 'action',
        "data-index": index,
        "data-tag-id": tag._id,
        "active": tag._id === _vm.activeTagId
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.setActiveTagId(tag._id);
        }
      }
    }, 'tag-action', tag, false)) : _vm._e(), tag.type === 'reference' && tag.isVisible ? _c('tag-reference', _vm._b({
      key: "reference-".concat(tag._id),
      attrs: {
        "data-type": "reference",
        "data-index": index,
        "data-tag-id": tag._id,
        "active": tag._id === _vm.activeTagId
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.setActiveTagId(tag._id);
        }
      }
    }, 'tag-reference', tag, false)) : _vm._e(), _vm._l(tag.polygons, function (polygon) {
      return _c('polygon-shape', {
        key: polygon._id,
        attrs: {
          "polygon": polygon
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.triggerTagFromPolygon(tag, $event);
          }
        }
      });
    })];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }